@if (captchaSiteKey$ | async; as captchaSiteKey) {
<div class="row form-group">
  <div [ngClass]="cssClass()">
    <div [ngClass]="{ 'has-error': hasError }">
      <re-captcha [siteKey]="captchaSiteKey" (resolved)="resolved($event)" class="captcha" />
      @if (hasError) {
      <small class="validation-message">{{ 'recaptcha.v2.incorrect.error' | translate }}</small>
      }
    </div>
  </div>
</div>
}
